"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consumer = exports.Provider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var AccordionContext_1 = require("./AccordionContext");
var Context = React.createContext(null);
var Provider = function (_a) {
    var children = _a.children, uuid = _a.uuid, accordionContext = _a.accordionContext, dangerouslySetExpanded = _a.dangerouslySetExpanded;
    var toggleExpanded = function () {
        accordionContext.toggleExpanded(uuid);
    };
    var variant = accordionContext.variant;
    var renderChildren = function (accordionContext) {
        var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : accordionContext.isItemExpanded(uuid);
        var disabled = accordionContext.isItemDisabled(uuid);
        var panelAttributes = accordionContext.getPanelAttributes(uuid, dangerouslySetExpanded);
        var headingAttributes = accordionContext.getHeadingAttributes(uuid);
        var buttonAttributes = accordionContext.getButtonAttributes(uuid, dangerouslySetExpanded);
        return ((0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: {
                uuid: uuid,
                expanded: expanded,
                disabled: disabled,
                toggleExpanded: toggleExpanded,
                panelAttributes: panelAttributes,
                headingAttributes: headingAttributes,
                buttonAttributes: buttonAttributes,
                variant: variant,
            } }, { children: children })));
    };
    return (0, jsx_runtime_1.jsx)(AccordionContext_1.Consumer, { children: renderChildren });
};
var ProviderWrapper = function (props) { return ((0, jsx_runtime_1.jsx)(AccordionContext_1.Consumer, { children: function (accordionContext) { return ((0, jsx_runtime_1.jsx)(Provider, __assign({}, props, { accordionContext: accordionContext }))); } })); };
exports.Provider = ProviderWrapper;
var Consumer = function (_a) {
    var children = _a.children;
    var renderChildren = function (container) {
        return container ? children(container) : null;
    };
    return (0, jsx_runtime_1.jsx)(Context.Consumer, { children: renderChildren });
};
exports.Consumer = Consumer;
//# sourceMappingURL=ItemContext.js.map